/**
 * Relative-time formatting for the reports product.
 *
 * Single source of truth for the "how long ago" string shown in the reports
 * list, block freshness chips, and the dashboard "Updated …" caption.
 *
 * Returns a self-contained phrase — callers render it verbatim (or prefix it
 * with "Updated "). It already carries the "ago" suffix where appropriate, so
 * DON'T append " ago" at the call site (that produced "just now ago").
 *
 *   relativeTime(thirtySecondsAgo) → "just now"
 *   relativeTime(fiveMinutesAgo)   → "5m ago"
 *   relativeTime(threeHoursAgo)    → "3h ago"
 *   relativeTime(twoDaysAgo)       → "2d ago"
 */
export function relativeTime(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}
